export default __webpack_public_path__ + "static/O0057-25f0aaefccdc34538aa840698bf7be00.png";